import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import useUpdateApplication from 'features/application/hooks/useUpdateApplication';
import PersonalInfo from 'features/application/screens/PersonalInfo/PersonalInfo';
import useReactivationPrefillData from 'features/reactivation/hooks/useReactivationPrefillData';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PersonalInfoWrapper = () => {
  const {
    prefillData,
    prefillDataFetching,
    prefillDataError,
    refetch: refetchPrefillData,
    reactivationApplicationId,
  } = useReactivationPrefillData();

  const {
    updateApplication,
    updateApplicationResult,
    isUpdateApplicationLoading,
    isUpdateApplicationSuccess,
  } = useUpdateApplication({
    applicationId: reactivationApplicationId,
    sourceName: SourceName.REACTIVATION_PERSONAL_INFO,
  });

  const { t: translatedText } = useTranslation('reactivation', {
    keyPrefix: 'personalInfo',
  });

  return (
    <PersonalInfo
      firstName={prefillData?.name.first as string}
      lastName={prefillData?.name.last as string}
      applicationId={reactivationApplicationId}
      isReapplication={false}
      hasApplicationLoaded={!!reactivationApplicationId}
      updateApplication={updateApplication}
      updateApplicationResult={updateApplicationResult}
      reExecuteQuery={refetchPrefillData}
      isUpdateApplicationLoading={isUpdateApplicationLoading}
      fetching={prefillDataFetching}
      error={prefillDataError as Error}
      isUpdateApplicationSuccess={isUpdateApplicationSuccess}
      isReactivation
      buttonLabel={translatedText('buttons.save')}
      nextRoute="/reactivation/review-info"
      backRoute="/reactivation/review-info"
    />
  );
};

export default PersonalInfoWrapper;
